import { assocPath, path } from 'ramda';

export function initUniqEventLocalStorage() {
  return {
    getData,
    saveData,
  };

  function saveData(data) {
    localStorage.setItem('uniqueEventStorage', JSON.stringify(data));
  }

  function getData() {
    const storage = JSON.parse(localStorage.getItem('uniqueEventStorage') || '{}');
    return storage;
  }
}

export function initUniqEventInMemoryStorage() {
  let storage = {};

  return {
    getData,
    saveData,
  };

  function saveData(data) {
    storage = data;
  }

  function getData() {
    return storage;
  }
}

export function prepareUniqPhotoIdsByEventName(eventName, storage = initUniqEventLocalStorage()) {
  return (photosId) => {
    const data = storage.getData();

    const preparedPhotos = filterUniq(eventName, photosId, data);

    const updatedData = addToStorage(eventName, photosId, data);

    storage.saveData(updatedData);

    return preparedPhotos;
  };

  function filterUniq(eventName, photosId, storage) {
    return photosId.filter((photoId) => path([eventName, photoId], storage) !== true);
  }

  function addToStorage(eventName, photosId, storage = {}) {
    return photosId.reduce((storage0, photoId) => assocPath([eventName, photoId.toString()], true, storage0), storage);
  }
}
